import { Effect } from "../Materials/effect";
var name = 'displayPassPixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nuniform sampler2D passSampler;\nvoid main(void)\n{\ngl_FragColor=texture2D(passSampler,vUV);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var displayPassPixelShader = { name: name, shader: shader };
//# sourceMappingURL=displayPass.fragment.js.map